import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { AerationScheduleLayout, navigateTo } from '@amber-ui/core';

function AerationScheduleRoute() {
  const { bin } = Route.useSearch();

  const onSubmitSuccess = useCallback(() => {
    navigateTo('/grain_bin/dashboard');
  }, []);

  if (!bin) return null;

  return <AerationScheduleLayout grain_bin_id={bin} onSubmitSuccess={onSubmitSuccess} />;
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/aeration_schedule')({
  component: AerationScheduleRoute,
});
